// El borrador de la caja del agente del Catálogo en el teléfono —
// ADR-2026-10-16-el-borrador-de-la-caja-del-catalogo-sobrevive (y -2).
import type { ChatAttachment } from '../../agentAttachments';

/** Lo escrito en la caja y sin mandar. Vive en quien la monta: la caja se desmonta al ver la
 *  conversación o al cerrarla, y el borrador tiene que estar cuando vuelve. `envio` sube con
 *  cada envío: un adjunto que termina de subir después no cae en el borrador siguiente
 *  (ADR-2026-10-16-el-borrador-de-la-caja-del-catalogo-sobrevive-2). */
export type BorradorDelAgente = { texto: string; adjuntos: ChatAttachment[]; envio: number };
export const BORRADOR_VACIO: BorradorDelAgente = { texto: '', adjuntos: [], envio: 0 };

/** El borrador después de mandarlo: vacío y con el envío siguiente. */
export const borradorDespuesDeEnviar = (b: BorradorDelAgente): BorradorDelAgente => ({ ...BORRADOR_VACIO, envio: b.envio + 1 });

/** Suma un adjunto sólo si el borrador sigue siendo el mismo envío en que empezó a subir. */
export const sumarAdjuntoAlBorrador =
  (envio: number, a: ChatAttachment) =>
  (b: BorradorDelAgente): BorradorDelAgente =>
    b.envio === envio ? { ...b, adjuntos: [...b.adjuntos, a] } : b;

/** Si el envío falló, vuelve lo que se mandó (ADR-2026-10-16-el-borrador-de-la-caja-del-catalogo-sobrevive-3),
 *  salvo que la persona ya haya empezado otro pedido: eso no se pisa. Queda en el envío nuevo,
 *  así un adjunto viejo que termine tarde tampoco entra. */
export const restaurarBorrador =
  (mandado: BorradorDelAgente) =>
  (actual: BorradorDelAgente): BorradorDelAgente =>
    actual.texto.trim() || actual.adjuntos.length > 0 ? actual : { ...mandado, envio: actual.envio };
